import PropertyList from './PropertyList.jsx'

export default PropertyList
